import { request } from '@umijs/max';

export type Result<T> = {
  code: number;
  message: string;
  success?: boolean;
  data: T;
};

export type IPage<T> = {
  records: T[];
  total: number;
  size: number;
  current: number;
  pages?: number;
};

/** 列表筛选用状态（不含草稿 0） */
export type CertStatusFilter = 1 | 2 | 3;

export const CERT_STATUS = {
  PENDING: 1 as CertStatusFilter,
  REJECTED: 2 as CertStatusFilter,
  APPROVED: 3 as CertStatusFilter,
};

export const CERT_STATUS_LABEL: Record<CertStatusFilter, string> = {
  1: '待审核',
  2: '已驳回',
  3: '已通过',
};

export type OpenCertListItem = {
  id: number;
  developerId: number;
  enterpriseFullName: string;
  email: string;
  creditCode: string;
  submittedAt?: string;
  certStatus: CertStatusFilter;
};

export type CertAuditLog = {
  action?: string;
  fromStatus?: number;
  toStatus?: number;
  comment?: string;
  operatorId?: number;
  operatorRole?: number;
  createTime?: string;
};

export type OpenCertDetail = {
  id: number;
  developerId?: number;
  enterpriseFullName?: string;
  creditCode?: string;
  legalPerson?: string;
  email?: string;
  licenseUrl?: string;
  certStatus: CertStatusFilter;
  rejectReason?: string;
  submittedAt?: string;
  reviewedAt?: string;
  reviewedBy?: number | string;
  auditLogs?: CertAuditLog[];
};

export type OpenCertPageRequest = {
  current?: number;
  size?: number;
  status?: CertStatusFilter;
};

export async function getPendingCertCount() {
  return request<Result<{ count: number }>>('/admin/open/cert/pending-count', {
    method: 'GET',
  });
}

export async function getOpenCertPage(body: OpenCertPageRequest) {
  return request<Result<IPage<OpenCertListItem>>>('/admin/open/cert/page', {
    method: 'POST',
    data: body,
  });
}

export async function getOpenCertDetail(id: number) {
  return request<Result<OpenCertDetail>>(`/admin/open/cert/${id}`, {
    method: 'GET',
  });
}

export async function approveOpenCert(id: number) {
  return request<Result<null>>(`/admin/open/cert/${id}/approve`, {
    method: 'POST',
  });
}

export async function rejectOpenCert(id: number, comment: string) {
  return request<Result<null>>(`/admin/open/cert/${id}/reject`, {
    method: 'POST',
    data: { comment },
  });
}

export function isLicenseImage(url?: string): boolean {
  if (!url) return false;
  return /\.(jpe?g|png|gif|webp)(\?|$)/i.test(url);
}

export function isLicensePdf(url?: string): boolean {
  if (!url) return false;
  return /\.pdf(\?|$)/i.test(url);
}
